import { useCallback, useState } from 'react';

import fetchLanguageResource, { initializedLanguages } from 'services/common/fetchLanguageResource';

import { store } from 'utils/configureStore';

const usePrintLocale = () => {
	const [printLocale, setPrintLocale] = useState(store.getState().printSettings?.printLocale);

	const languageListener = () => {
		const locale = store.getState().printSettings?.printLocale;
		setPrintLocale(locale);
	};

	const fetchLanguage = useCallback(
		async (langs) => {
			const langsToFetch = Array.isArray(langs) ? langs : [langs];

			const promises = langsToFetch
				.filter((lang) => !initializedLanguages?.includes(lang))
				.map((lng) => fetchLanguageResource(lng));
			await Promise.all(promises)
				.then(() => true)
				.catch(() => false);
		},
		[initializedLanguages]
	);

	store.subscribe(languageListener);

	return { printLocale, fetchLanguage };
};

export default usePrintLocale;
